import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";
export interface AddLastMilePayload{
  idCharge: string;
  id: number;
  vendorId: number;
  state:string;
  city: string;
  countryId: string;
  zip_start: string;
  zip_end: string;
}

//GET  /v1/lastmilleinventory
export function getLastMiles(token: string){
  return axios.get( `${API_URL}/v1/lastmilleinventory`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
}

//GET  /v1/lastmilleinventory/id
export function getLastMilebyId(token: string, id:number){
	const encodedId = encodeURIComponent(id);
  return axios.get( `${API_URL}/v1/lastmilleinventory/${encodedId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
}

//GET v1/lastmillevendors/available
export function getVendorsList(token: string){
  return axios.get( `${API_URL}/v1/lastmillevendors/available`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
}

//POST v1/lastmilleinventory

export function addLastMile(token: string, payload: AddLastMilePayload) {
	return axios.post(`${API_URL}/v1/lastmilleinventory`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//PUT v1/lastmilleinventory/id
export function updateLastMile(
	token: string,
	id: number,
	payload: AddLastMilePayload
) {
	const encodedId = encodeURIComponent(id);
	return axios.put(`${API_URL}/v1/lastmilleinventory/${encodedId}`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//Delete --> TODO
export function deleteLastMile(token: string, id: number) {
	const encodedId = encodeURIComponent(id);
	return axios.delete(`${API_URL}/v1/lastmilleinventory/${encodedId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}